import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/gStationConnect/gStationConnect.ts";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { DocumentManagement } from '../GStationApi/DocumentManagement';
export function gStationConnect(gStationService) {
  DocumentManagement.fetchModelDerivative.use(function (_ref) {
    var projectId = _ref.projectId,
        body = _objectWithoutProperties(_ref, ["projectId"]);

    return gStationService.post("/v1/projects/".concat(projectId, "/derivatives/search"), body).then(DocumentManagement.fetchModelDerivative.toPromise);
  });
}